import { PriceForecast } from "@b2bportal/core-flights";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Button, ButtonTypeEnum, Icon } from "@tenant/ui";
import { PricePredictionDialog } from "../PricePredictionDialog/PricePredictionDialog";
import { WatchTripDialog } from "../WatchTripDialog/WatchTripDialog";
import { usePricePrediction } from "./hooks/usePricePrediction";
import styles from "./styles.module.scss";
import { TenantIconNameEnum } from "@/types/tenantIcons";

export const PricePredictionCard = () => {
  const { t, brand } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PricePredictionCard");

  const pricePredictionReturn = usePricePrediction();

  const {
    context: {
      title,
      subtitle,
      prediction,
      items,
      isWatching,
      lowestPrice,
      priceOnTripCategory,
    },
    watchTripDialogProps,
    learnMoreDialogProps,
  } = pricePredictionReturn;

  const redirectToTermsAndConditions = () => {
    window.open(
      brand.urls.pricePredictionTerms,
      "_blank",
      "noopener,noreferrer"
    );
  };

  if (!prediction?.dealness) {
    return null;
  }

  return (
    <div className={block}>
      <div className={cn("prediction-container")}>
        <div className={cn("prediction-content")}>
          <div className={cn("prediction-left")}>
            <p className={cn("recommendation-text")}>{subtitle}</p>
            <p className={cn("prediction-text")}>
              {title}
              <PricePredictionDialog
                className={cn("learn-more-button")}
                {...learnMoreDialogProps}
                watchTripAction={watchTripDialogProps.onOpen}
                {...pricePredictionReturn}
              >
                <Icon iconName={IconNameEnum.cfar__info} />
              </PricePredictionDialog>
            </p>
          </div>
          <div className={cn("prediction-right")}>
            <p className={cn("current-price-title")}>
              {t("pricePrediction.currentPrice")}:
            </p>
            <p className={cn("current-price")}>{lowestPrice}</p>
            <p className={cn("current-price-trip-category")}>
              {priceOnTripCategory}
            </p>
          </div>
        </div>
        <PriceForecast items={items} dealness={prediction?.dealness} />
        <Button
          className={cn("terms-and-conditions-link")}
          buttonType={ButtonTypeEnum.Link}
          onClick={redirectToTermsAndConditions}
          aria-label={t("pricePrediction.termsAndConditionsLink")}
        >
          {t("pricePrediction.termsAndConditionsLink")}
        </Button>
      </div>

      <div className={cn("watch-container")}>
        {isWatching ? (
          <>
            <div className={cn("watching-icon")}>
              <Icon iconName={TenantIconNameEnum.watchActive} useCurrentColor />
            </div>
            <p className={cn("watching-title")}>
              {t("priceWatch.titles.watchedHeader")}
            </p>
          </>
        ) : (
          <div>
            <p className={cn("watch-container-title")}>
              {t("core-flights.shopPage.notReadyToBook")}
            </p>
            <p className={cn("watch-container-description")}>
              {t("priceWatch.copy")}
            </p>
          </div>
        )}
        <WatchTripDialog
          className={cn("watch-trip-button")}
          {...watchTripDialogProps}
        >
          <span
            className={
              isWatching ? cn("stop-watching-link") : cn("watch-action")
            }
          >
            {isWatching ? t("priceWatch.watching") : t("priceWatch.watchTrip")}
          </span>
        </WatchTripDialog>
      </div>
    </div>
  );
};
